var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.08-462.31h35.38v-80h61.92l18.08-18.07v-79.24l-18.08-18.07h-97.3zm35.38-115.38v-44.62h44.62v44.62zm120.77 115.38H605l18.08-18.07v-159.24L605-657.69h-95.77zm35.38-35.38v-124.62h43.08v124.62zm123.08 35.38h35.39v-80h47.69v-35.38h-47.69v-44.62h47.69v-35.38h-83.08zM250-260v-600h600v600zm60-60h480v-480H310zM110-120v-587.69h60V-180h527.69v60zm200-680v480z"
  })));
};
export default SvgPdf;